export default {
    title: '特許審査',
    noSessions: '審査記録がありません',
    noSessionsHint: '特許審査ツールを実行すると、結果がここに表示されます',
    rules: '件のルール',
    loadFailed: '読み込みに失敗しました。再試行してください',
    view: {
        issues: '問題一覧',
        patent: '特許原文',
    },
    filter: {
        all: 'すべて',
        critical: '重大',
        error: 'エラー',
        warning: '警告',
        pass: '合格',
    },
    issue: {
        ignore: '無視',
        ignored: '無視済み',
        applied: '適用済み',
        pending: '保留中',
        expired: '期限切れ',
        ignoreSuccess: '無視しました',
        ignoreFailed: '操作に失敗しました',
    },
    passCollapsed: '合格 ({count} 件)',
    expand: '展開',
    collapse: '折りたたむ',
    uncategorized: '未分類',
    noIssuesInSection: 'このセクションに問題はありません',
    patent: {
        loading: '読み込み中...',
        loadError: '読み込みに失敗しました。再試行してください',
        noContent: 'コンテンツがありません',
        background: '背景技術',
        description: '発明の内容',
    },
    field: {
        location: '位置',
        description: '問題の説明',
        suggestion: '修正提案',
        oldContent: '原文',
        newContent: '修正後',
        source: '根拠',
    },
    section: {
        abstract: '要約',
        claims: '特許請求の範囲',
        title: 'タイトル',
        specification: '明細書',
    },
    taskRunning: '現在タスクが実行中です。タスクが完了してから審査を開始してください。',
    newReview: '新規核稿',
    selectDocument: 'ドキュメントを選択',
    noDocuments: 'ドキュメントなし',
    reviewPrompt: '特許審査ツールを使用して審査する',
    partialReviewPrompt: '以下の指定した審査ルールのみを使用して部分審査してください。ルール ID と説明：',
    backToList: '戻る',
    startReview: '全体審査',
    partialReview: '部分審査',
    selectRules: 'ルール選択',
    words: '文字',
    partialReviewDialog: {
        title: '部分審査ルールを選択',
        searchPlaceholder: 'ルール ID または説明を検索...',
        selectedCount: '{count} 件選択済み',
        empty: '選択可能なルールがありません',
        noSelection: '審査ルールを 1 件以上選択してください',
        cancel: 'キャンセル',
        confirm: '審査を開始',
        source: {
            custom: 'マイルール',
            system: 'システムルール',
        },
    },
    tab: {
        review: '特許審査',
        rules: 'ルール管理',
    },
    customRules: {
        loadFailed: 'ルールの読み込みに失敗しました',
        createSuccess: 'ルールを作成しました',
        createFailed: 'ルールの作成に失敗しました',
        updateSuccess: 'ルールを更新しました',
        updateFailed: 'ルールの更新に失敗しました',
        deleteSuccess: 'ルールを削除しました',
        deleteFailed: 'ルールの削除に失敗しました',
        create: '新規ルール',
        searchPlaceholder: 'ルールを検索...',
        edit: '編集',
        delete: '削除',
        deleteConfirm: 'このルールを削除しますか？',
        confirmYes: '確認',
        confirmNo: 'キャンセル',
        empty: 'カスタムルールがありません',
        systemEmpty: 'システムルールがありません',
        systemBadge: 'システム',
        viewMy: 'マイルール',
        viewSystem: 'システムルール',
        col: {
            ruleId: 'ルールID',
            patentOffice: '特許庁',
            category: 'カテゴリ',
            severity: '重要度',
            description: '説明',
            message: 'メッセージ',
            status: 'ステータス',
            createdAt: '作成日',
            actions: '操作',
        },
        filter: {
            patentOffice: '特許庁',
            category: 'カテゴリ',
            status: 'ステータス',
            enabled: '有効',
            disabled: '無効',
        },
        category: {
            claims: '特許請求の範囲',
            abstract: '要約',
            title: 'タイトル',
            specification: '明細書',
            drawing_description: '図面の説明',
            invention_content: '発明の内容',
            field: '技術分野',
            punctuation: '句読点',
            implementation: '発明を実施するための形態',
            background: '背景技術',
            figures: '図面',
        },
        severity: {
            error: 'エラー',
            warning: '警告',
            info: '情報',
        },
        field: {
            patentOffice: '特許庁',
            category: 'カテゴリ',
            severity: '重要度',
            description: 'ルール説明',
            descriptionPlaceholder: '例：背景技術は関連する先行技術を客観的に説明すること',
            message: 'メッセージ',
            messagePlaceholder: '例：背景技術の記載が要件を満たしていません',
            suggestion: '修正提案',
            suggestionPlaceholder: '例：関連する先行技術を客観的に説明し、本発明が解決すべき技術的課題を示すこと',
            requirement: '要件',
            requirementPlaceholder: '例：\n発明の理解・調査・審査に有用な背景技術を記載する\n先行技術の問題点・欠点を客観的に指摘する\n本発明が解決しようとする問題のみを指摘する',
            requirementHint: '1行に1つの要件',
        },
        drawer: {
            titleCreate: '新規ルール',
            titleEdit: 'ルールを編集',
            cancel: 'キャンセル',
            submit: '保存',
            submitting: '保存中...',
        },
        validation: {
            required: 'この項目は必須です',
        },
    },
    functions: {
        independentPatentReview: '独立特許審査',
    },
};
